import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';

export default function Email({
  handleSettingsClick,
  item,
  index,
  isFormBuilder,
  relationFieldName,
  isRelation = false,
  isFromPreview = false,
}) {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const { subtext, required, label = 'Short Text' } = item || {};
  const name = isRelation ? relationFieldName : item?.field_name || `form_data.${index}.value`;

  return (
    <div className="w-100">
      <LabelName>
        {label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap">
        <Controller
          name={name}
          control={control}
          rules={
            isFormBuilder
              ? {}
              : {
                  required: required ? 'Required Field' : false,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Entered value does not match email format',
                  },
                }
          }
          render={({ field, fieldState }) => (
            <InputText
              placeholder="Type in email"
              id={field.name}
              onChange={(e) => {
                const trimmedValue = e.target.value.trim();
                field.onChange(trimmedValue);
                if (item?.field_name && !isRelation) {
                  setValue(`form_data.${index}.value`, trimmedValue);
                }
              }}
              value={field.value || ''}
              className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 input-shadow': true })}
              style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
              ref={isFormBuilder ? null : field.ref}
            />
          )}
        />
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
